<template>
  <div id="app" :class="'route-' + ($route.name || 'page')">
    <Header></Header>
    <Breadcrumb></Breadcrumb>
    <div class="wrap">
    <keep-alive>
      <router-view ref="index" v-if="isRouterAlive"></router-view>
    </keep-alive>
    </div>
    <GeoGuide></GeoGuide>
    <Footer v-if="footer === true"></Footer><!--过滤底部-->
<!--    <Footer/> &lt;!&ndash;全部显示&ndash;&gt;-->
    <LoginPop v-if="showlogin == true"></LoginPop>
    <div class="copyright">
      <span>YAXUN SPORTS · 数据驱动的专业体育内容平台</span>
      <span>独立观点，仅供参考</span>
    </div>
  </div>
</template>

<script>
import Footer from './components/public/footer'
import LoginPop from './components/public/loginPop'
import Header from './components/public/header'
import Breadcrumb from './components/public/breadcrumb'
import GeoGuide from './components/public/GeoGuide'
import { mapGetters } from "vuex"

export default {
  name: 'App',
  computed: mapGetters(["footer", 'showlogin']),
  components: {
    LoginPop,
    Footer,
    Header,
    Breadcrumb,
    GeoGuide,
  },
  data(){
    return {
      isRouterAlive: true
    }
  },
  provide(){
    return {
      reload: this.reload
    }
  },
  methods: {
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}

// npm run build
</script>

<style>
</style>
